export default __webpack_public_path__ + "images/93406c8870e7a17268862fd9c592ac5d.svg";